var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRename = function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 1a.778.778 0 0 0-.778.778v12.444a.778.778 0 1 0 1.555 0V1.778A.778.778 0 0 0 13.667 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.73 12.154-.654-1.363H4.239l-.655 1.363a.852.852 0 0 1-.484.442.806.806 0 0 1-.641-.046.87.87 0 0 1-.417-.51.916.916 0 0 1 .047-.668l4.048-8.478a.586.586 0 0 1 .525-.339c.221 0 .424.131.524.339l4.048 8.478a.917.917 0 0 1 .06.682.87.87 0 0 1-.427.52.805.805 0 0 1-.653.042.855.855 0 0 1-.483-.462ZM6.657 5.966a.192.192 0 0 0-.168.102L5.08 9.032h3.157L6.826 6.07a.192.192 0 0 0-.168-.103Z"
  })));
};
export default SvgRename;